export default "__VITE_ASSET__D1Z3yRdI__"